/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Box, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { snakeCase } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const VListItem = ({ imgSrc, handleClose, auth, label, isActive = false, navigateTo, ...props }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.auth);
  const finishedTrial = currentUser?.info?.finishedTrial;
  const navigate = useNavigate();

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (finishedTrial) {
      setIsVisible(true);
    } else {
      setIsVisible(!auth);
    }
  }, [finishedTrial, auth]);

  if (!isVisible) return null;

  // BRAND COLORS
  const activeBg = theme.palette.secondary.main; // #1a4861
  const hoverBg = theme.palette.secondary.main + 'CC'; // 80% opacity
  const activeText = theme.palette.common.white;
  const inactiveText = theme.palette.text.primary; // #616973

  return (
    <ListItem {...props} sx={{ padding: 1 }}>
      <ListItemButton
        onClick={() => {
          if (navigateTo) {
            navigate(`/${navigateTo}`, { state: snakeCase(label) });
            handleClose && handleClose();
          }
        }}
        sx={{
          display: 'flex',
          borderRadius: theme.shape.borderRadius * 1,
          height: '40px',
          color: activeText,
          bgcolor: isActive ? activeBg : 'transparent',
          transition: 'all 0.15s ease-in-out',

          '& img': {
            filter: 'brightness(100)', // fully white
          },

          '&:hover': {
            bgcolor: hoverBg,
            color: activeText,
            '& img': {
              filter: 'brightness(100)',
            },
          },
        }}
      >
        {/* ICON */}
        <ListItemIcon sx={{ minWidth: '40px' }}>
          <Box
            component="img"
            src={imgSrc}
            sx={{
              width: 22,
              height: 22,
              objectFit: 'contain',
            }}
          />
        </ListItemIcon>

        {/* LABEL */}
        <ListItemText>
          <Typography sx={{ lineHeight: '18px' }} fontWeight={isActive ? 700 : 400} variant="body1">
            {t(label)}
          </Typography>
        </ListItemText>
      </ListItemButton>
    </ListItem>
  );
};

export default VListItem;
